import {APIError} from 'data/errors';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetRefundProtocolStatus,
	GetRefundProtocolStatusParams,
	GetRefundProtocolStatusResponse,
} from 'domain/usecases/private/refund/consult-refunds/get-refund-protocol-status';

export class RemoteGetRefundProtocolStatus implements GetRefundProtocolStatus {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetRefundProtocolStatusResponse>,
	) {}

	async get(params: GetRefundProtocolStatusParams): Promise<GetRefundProtocolStatusResponse> {
		const {signal, ...otherParams} = params;

		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params: otherParams,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
